import { Children, FC, ReactElement, useState } from 'react';
import { WbTabs } from '../WbTabs';
import { WbTabProps } from '../WbTabs/WbTab';
import { WbCard, WbCardProps } from './WbCard';

interface Props extends WbCardProps {
  label?: string | JSX.Element;
}

export const WbCardWithTabs: FC<Props> = props => {
  const tabs = Children.map(
    props.children as ReactElement<WbTabProps>,
    (child: ReactElement<WbTabProps>) => child.props,
  );
  const [selectedTab, setSelectedTab] = useState<string>(tabs[0].name);

  return (
    <WbCard
      {...props}
      toolsComponents={
        <>
          {props.label}
          <WbTabs
            tabs={tabs.map(tab => ({
              name: tab.name,
              action: () => {
                setSelectedTab(tab.name);
                tab.action?.();
              },
              selected: tab.name === selectedTab,
            }))}
          />
        </>
      }
    >
      {Children.map(
        props.children as ReactElement<WbTabProps>,
        (child: ReactElement<WbTabProps>) => child,
      ).filter(child => child.props.name === selectedTab)}
    </WbCard>
  );
};
